module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_8011.b3e56386.png";